<mat-card class="payment-card" [class.has-overdue]="hasOverdue" [@fadeIn]>
  <mat-card-header>
    <mat-card-title>
      Pagamento #{{ payment.id }}
      <mat-icon *ngIf="hasOverdue" color="warn" matTooltip="Parcelas atrasadas" class="warning-icon">
        warning
      </mat-icon>
    </mat-card-title>
    <mat-chip [color]="getStatusColor()">
      {{ (payment.status || '') | enumDescription }}
    </mat-chip>
  </mat-card-header>

  <mat-card-content>
    <!-- Payment Info Grid -->
    <div class="payment-info-grid">
      <div class="info-item">
        <mat-icon>payment</mat-icon>
        <span>{{ (payment.method || '') | enumDescription }}</span>
      </div>
      <div class="info-item">
        <mat-icon>receipt</mat-icon>
        <span>Plano #{{ payment.accessPlanId || 'N/A' }}</span>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- Progress Section -->
    <div class="progress-section">
      <div class="progress-header">
        <span class="label">Progresso de Parcelas</span>
        <span class="value">{{ getPaidCount() }}/{{ payment.installments?.length || 0 }}</span>
      </div>
      <mat-progress-bar 
        mode="determinate" 
        [value]="getProgressPercentage()"
        [color]="hasOverdue ? 'warn' : 'primary'">
      </mat-progress-bar>
      <span class="progress-percentage">{{ getProgressPercentage().toFixed(0) }}%</span>
    </div>

    <mat-divider></mat-divider>

    <!-- Financial Summary -->
    <div class="financial-summary">
      <div class="summary-row">
        <span class="label">Valor Total:</span>
        <span class="value">{{ formatCurrency(payment.totalAmount) }}</span>
      </div>
      <div class="summary-row">
        <span class="label">Valor Pago:</span>
        <span class="value paid">{{ formatCurrency(getTotalPaid()) }}</span>
      </div>
      <div class="summary-row">
        <span class="label">Valor Pendente:</span>
        <span class="value pending">{{ formatCurrency(getPendingAmount()) }}</span>
      </div>
    </div>

    <!-- Overdue Alert -->
    <mat-card class="overdue-alert" *ngIf="hasOverdue">
      <mat-icon>warning</mat-icon>
      <span>{{ getOverdueCount() }} parcela(s) atrasada(s)</span>
    </mat-card>
  </mat-card-content>

  <mat-card-actions>
    <button mat-button color="primary" (click)="onViewDetails()">
      <mat-icon>visibility</mat-icon>
      Ver Detalhes
    </button>
    <button mat-raised-button color="accent" 
            *ngIf="hasNextInstallmentToPay()"
            (click)="onPayNextInstallment()">
      <mat-icon>payment</mat-icon>
      Pagar Próxima
    </button>
  </mat-card-actions>
</mat-card>
